// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file realtime/watch_app_events.proto (package protos.realtime, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AppEventPayload } from "./app_event_payload_pb";
import { file_realtime_app_event_payload } from "./app_event_payload_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file realtime/watch_app_events.proto.
 */
export const file_realtime_watch_app_events: GenFile = /*@__PURE__*/
  fileDesc("Ch9yZWFsdGltZS93YXRjaF9hcHBfZXZlbnRzLnByb3RvEg9wcm90b3MucmVhbHRpbWUi/QEKFVdhdGNoQXBwRXZlbnRzUmVxdWVzdBJICgtzdGFydF93YXRjaBgBIAEoCzIxLnByb3Rvcy5yZWFsdGltZS5XYXRjaEFwcEV2ZW50c1JlcXVlc3QuU3RhcnRXYXRjaEgAGo4BCgpTdGFydFdhdGNoEkgKBnBhcmFtcxgBIAEoCzI4LnByb3Rvcy5yZWFsdGltZS5XYXRjaEFwcEV2ZW50c1JlcXVlc3QuU3RhcnRXYXRjaC5QYXJhbXMaNgoGUGFyYW1zEiwKCHN0YXJ0X2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIJCgdyZXF1ZXN0IsEBChZXYXRjaEFwcEV2ZW50c1Jlc3BvbnNlEj4KBnJlc3VsdBgBIAEoCzIuLnByb3Rvcy5yZWFsdGltZS5XYXRjaEFwcEV2ZW50c1Jlc3BvbnNlLlJlc3VsdBpnCgZSZXN1bHQSLwoFZXZlbnQYASABKAsyIC5wcm90b3MucmVhbHRpbWUuQXBwRXZlbnRQYXlsb2FkEiwKCHN0YXJ0X2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp, file_realtime_app_event_payload]);

/**
 * @generated from message protos.realtime.WatchAppEventsRequest
 */
export type WatchAppEventsRequest = Message<"protos.realtime.WatchAppEventsRequest"> & {
  /**
   * @generated from oneof protos.realtime.WatchAppEventsRequest.request
   */
  request: {
    /**
     * @generated from field: protos.realtime.WatchAppEventsRequest.StartWatch start_watch = 1;
     */
    value: WatchAppEventsRequest_StartWatch;
    case: "startWatch";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.realtime.WatchAppEventsRequest.
 * Use `create(WatchAppEventsRequestSchema)` to create a new message.
 */
export const WatchAppEventsRequestSchema: GenMessage<WatchAppEventsRequest> = /*@__PURE__*/
  messageDesc(file_realtime_watch_app_events, 0);

/**
 * @generated from message protos.realtime.WatchAppEventsRequest.StartWatch
 */
export type WatchAppEventsRequest_StartWatch = Message<"protos.realtime.WatchAppEventsRequest.StartWatch"> & {
  /**
   * @generated from field: protos.realtime.WatchAppEventsRequest.StartWatch.Params params = 1;
   */
  params?: WatchAppEventsRequest_StartWatch_Params | undefined;
};

/**
 * Describes the message protos.realtime.WatchAppEventsRequest.StartWatch.
 * Use `create(WatchAppEventsRequest_StartWatchSchema)` to create a new message.
 */
export const WatchAppEventsRequest_StartWatchSchema: GenMessage<WatchAppEventsRequest_StartWatch> = /*@__PURE__*/
  messageDesc(file_realtime_watch_app_events, 0, 0);

/**
 * @generated from message protos.realtime.WatchAppEventsRequest.StartWatch.Params
 */
export type WatchAppEventsRequest_StartWatch_Params = Message<"protos.realtime.WatchAppEventsRequest.StartWatch.Params"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_at = 1;
   */
  startAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.realtime.WatchAppEventsRequest.StartWatch.Params.
 * Use `create(WatchAppEventsRequest_StartWatch_ParamsSchema)` to create a new message.
 */
export const WatchAppEventsRequest_StartWatch_ParamsSchema: GenMessage<WatchAppEventsRequest_StartWatch_Params> = /*@__PURE__*/
  messageDesc(file_realtime_watch_app_events, 0, 0, 0);

/**
 * @generated from message protos.realtime.WatchAppEventsResponse
 */
export type WatchAppEventsResponse = Message<"protos.realtime.WatchAppEventsResponse"> & {
  /**
   * @generated from field: protos.realtime.WatchAppEventsResponse.Result result = 1;
   */
  result?: WatchAppEventsResponse_Result | undefined;
};

/**
 * Describes the message protos.realtime.WatchAppEventsResponse.
 * Use `create(WatchAppEventsResponseSchema)` to create a new message.
 */
export const WatchAppEventsResponseSchema: GenMessage<WatchAppEventsResponse> = /*@__PURE__*/
  messageDesc(file_realtime_watch_app_events, 1);

/**
 * @generated from message protos.realtime.WatchAppEventsResponse.Result
 */
export type WatchAppEventsResponse_Result = Message<"protos.realtime.WatchAppEventsResponse.Result"> & {
  /**
   * @generated from field: protos.realtime.AppEventPayload event = 1;
   */
  event?: AppEventPayload | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 2;
   */
  startAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.realtime.WatchAppEventsResponse.Result.
 * Use `create(WatchAppEventsResponse_ResultSchema)` to create a new message.
 */
export const WatchAppEventsResponse_ResultSchema: GenMessage<WatchAppEventsResponse_Result> = /*@__PURE__*/
  messageDesc(file_realtime_watch_app_events, 1, 0);

